<i18n>
{
    "en_US": {
        "input-forgot": "Input your email to reset your password.",
        "email": "Email",
        "nevermind": "Nevermind",
        "missing-email": "Email can't be blank",
        "recover-password": "Recover your password",
        "reset-your-password": "Reset your password"
    },
    "fr_FR": {
        "input-forgot": "Entrez votre email pour réinitialiser votre mot de passe.",
        "email": "Email",
        "nevermind": "Abandonner",
        "missing-email": "L'email ne peut pas être vide",
        "recover-password": "Récupérer votre mot de passe",
        "reset-your-password": "Réinitialiser votre mot de passe"
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="recover">
        <h1 class="text-left" v-text="$t('recover-password')"></h1>

        <slot name="flashes" />

        <p v-text="$t('input-forgot')"></p>

        <div class="form-group bmd-form-group">
            <label for="inputEmail" class="bmd-label-floating" v-text="$t('email')"></label>
            <input type="email" class="form-control bmb-control" id="inputEmail" v-model="email" v-bind:disabled="pending.password_lost" required />
        </div>

        <button class="btn btn-lg btn-primary btn-block" type="submit" v-bind:disabled="isAllowedButton">
            <loader-basic-spinner v-if="pending.password_lost" />
            <a v-else v-text="$t('reset-your-password')"></a>
        </button>

        <a class="nevermind" v-on:click="login" v-text="$t('nevermind')"></a>
    </form>
</template>

<script>
    import { mapState, mapMutations, mapActions } from "vuex";
    import LoaderBasicSpinner from "loaders/BasicSpinner";

    export default {
        name: "PasswordLost",
        data: function() {
            return {
                email: ""
            };
        },
        components: {
            LoaderBasicSpinner
        },
        mounted: function() {
            $(this.$el).bootstrapMaterialDesign();
            $(this.$el).find("#inputEmail").focus();
        },
        computed: {
            isAllowedButton: function() {
                return this.pending.password_lost || !this.email;
            },
            ...mapState("user", ["pending"])
        },
        methods: {
            login: function() {
                this.$router.push({
                    name: "login"
                });
            },
            recover: function() {
                if (!this.email) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("missing-email"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                this.passwordLost({
                    email: this.email
                })
                    .then(function() {
                        this.$Progress.finish();
                        this.$router.push({ name: "login" });
                    }.bind(this))
                    .catch(function() {});
            },
            ...mapMutations("flash", ["addFlash"]),
            ...mapActions("user", ["passwordLost"])
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 20px;
        margin-bottom: 30px;
        color: #666;
        font-weight: 300;
        font-size: 20px;
    }
    .bmb-form-group {
        padding-top: 1.3rem !important;
    }
    button {
        margin-bottom: 0;
        margin-top: 50px;
        font-weight: 100;
        font-size: 18px !important;
        line-height: 1.3333333333;
    }
    .bmd-label-floating {
        left: 0;
    }
    .form-group label {
        font-weight: bold;
        font-size: 14px;
    }
    .nevermind {
        display: block;
        margin-top: 25px;
        font-size: 14px;
        font-weight: 300;
        cursor: pointer;
    }
    p {
        margin-top: 25px;
        color: rgb(118, 131, 143);
        font-size: 14px;
        font-weight: 300;
    }
</style>